import type { ClientError } from '@tribeplatform/gql-client/lib'
import type { Member } from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getAuthMemberKey } from '../../utils/keys/authToken.keys.js'

export const useRevokeSupportAccess = (options?: {
  useMutationOptions?: UseMutationOptions<Member, ClientError, void>
}) => {
  const { useMutationOptions } = options || {}
  const queryClient = useQueryClient()
  const { client } = useTribeClient()

  return useMutation<Member, ClientError, void>(
    () =>
      client.mutation({
        name: 'revokeSupportAccess',
        args: { fields: 'basic' },
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(getAuthMemberKey())
      },
      ...useMutationOptions,
    },
  )
}
